import { type LicenceType } from '~/domains/core';
import type { BasketTypeResponse } from '~/domains/basket';

export default function getFilteredBaskets(
  baskets: BasketTypeResponse[],
  type: LicenceType,
): BasketTypeResponse[] {
  return baskets.filter((basket) => basket.type === type);
}
